import { useNavigate, useLocation } from "react-router-dom";

export default function ScrollLink({ to, hash, children, className }) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = (e) => {
    e.preventDefault();

    if (location.pathname !== to) {
      // Primero navega a /landing
      navigate(to);
      // Luego hace scroll al id
      setTimeout(() => {
        const el = document.getElementById(hash);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 100);
    } else {
      // Ya estamos en /landing → solo scroll
      const el = document.getElementById(hash);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <a href={`#${hash}`} className={className} onClick={handleClick}>
      {children}
    </a>
  );
}
